import React, { useState, useEffect, useMemo } from "react"
import lodash from "lodash"
import styled from "styled-components"

import Currency from '../../../../../1stlog-ui/src/components/Currency'
import Flag from "./Flag"

const Wrapper = styled.div``

const Th = styled.th`
  vertical-align: center;
`

const Item = props => {
  const {
    count = 1,
    articleNumber,
    description,
    tariffNumber,
    exporttariffNumber,
    originCountry,
    preferenceCode,
    netWeight,
    grossWeight,
    value: { value, currency },
    taxCode,
    code
  } = props
  return (
    <tr>
      <td>{count}</td>
      <td>{articleNumber}</td>
      <td>{description}</td>
      <td>{exporttariffNumber || tariffNumber}</td>
      <td>
        <Flag code={originCountry} />
      </td>
      <td>{netWeight} kg</td>
      {/* <td>{grossWeight} kg</td> */}
      <td>
        <Currency value={value} currency={currency} />
      </td>
    </tr>
  )
}

const CustomsTable = props => {
  const { items } = props

  return (
    <Wrapper>
      <table className="table table-sm">
        <thead>
          <tr>
            <Th>Anzahl</Th>
            <Th>Artikelnr./Referenz</Th>
            <Th>Warenbezeichnung</Th>
            <Th>Zolltarif-Nr.</Th>
            <Th>Ursprungsland</Th>
            <Th>
              Nettogewicht
              <br />
              <small className="text-small">(Eigenmasse)</small>
            </Th>
            {/* <Th>
              Bruttogewicht
              <br />
              <small className="text-small">(inkl. Verpackung)</small>
            </Th> */}
            <Th>Wert</Th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => (
            <Item key={index} {...item} />
          ))}
        </tbody>
      </table>
    </Wrapper>
  )
}

export default CustomsTable
